module.exports = __webpack_public_path__ + "img/info.6921c23f.svg";